import React from 'react';
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Un botón que navega hacia atrás (-1) si hay historial, 
 * o a una ruta de "fallback" (por defecto '/') si no lo hay.
 * * @param {object} props - Propiedades del componente.
 * @param {string} [props.ruta='/'] - La ruta a la que ir si no hay historial (ej. /dashboard).
 */
export const BotonVolver = ({ ruta = '/' }) => {
  
  // 1. Los Hooks se llaman DENTRO del componente
  const location = useLocation();
  const navigate = useNavigate(); // <-- Necesitas esto para navegar

  // 2. Creamos la función controladora (handler)
  const handleRegresar = () => {
    // location.key es 'default' si el usuario entró directamente a esta URL
    if (location.key !== 'default') {
      navigate(-1); // Hay historial, vamos una página atrás
    } else {
      navigate(ruta); // No hay historial, vamos a la ruta de fallback
    }
  };

  return (
    <button 
      // 3. Pasamos la referencia a la función, no la ejecutamos
      onClick={handleRegresar} 
      className="text-gray-600 hover:text-gray-800 text-sm flex items-center"
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
      </svg>
      Volver
    </button>
  );
};

export const BotonAtras = (navigate, location, fallbackRoute = '/') => {
    // Si la llave es distinta de 'default', significa que hay historial en la sesión actual
    if (location.key !== 'default') {
        navigate(-1); 
    } else {
        // Si entró desde un enlace externo (correo/whatsapp), lo mandamos a la solicitud
        navigate(fallbackRoute); 
    }
}

export const formatearNombreURL = (nombre) => {
  if (!nombre) return '';
  // Limpia espacios y podrías agregar .toLowerCase() si prefieres URLs en minúsculas
  return nombre.trim().replace(/\s+/g, '_'); 
};

export const GeneralRoutes  = {

  irADetalle: (navigate, solicitud) => {
    if (!solicitud?.nombreEmpresa || !solicitud?.id) return;
        
    navigate(`/dashboard/detalle_solicitud/${formatearNombreURL(solicitud.nombreEmpresa)}/${solicitud.id}`);
  },
  irADetalleServicio: (navigate , servicio) => {
    if (!servicio?.nombreEmpresa || !servicio?.codigo) return;

    navigate(`/contabilidad/detalles_servicio/${formatearNombreURL(servicio.nombreEmpresa)}/${servicio.codigo}`);
  },
  irAVerTransaccion: (navigate, idTransaccion) => {
    if (!idTransaccion) return;

    const texto = 'pago';

    navigate(`/pago/resultado/${idTransaccion}/:${texto}`);

  }

}
